import Dashboard from "./index";
import {usePermissions} from "react-admin";

const CatalogOffersDashboard = () => {
    const {permissions} = usePermissions();
    return <Dashboard permissions={permissions} forCatalogOffers={true} />
};

export default CatalogOffersDashboard;
